import { Loader } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'
import { DisabledModal } from '../DisabledModal'
import styles from './styles.module.css'

export const LoaderModal: FunctionComponent = () => {
  return (
    <DisabledModal overlay='dark'>
      <div className={styles.loaderWrapper}>
        <Loader pulseKind='White' />
      </div>
    </DisabledModal>
  )
}
